import { queryKeys } from '@/lib/query-keys';
import { catalogAdminClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';


// Device Models hooks
export const useDeviceModels = (activeOnly?: boolean) => {
  return useQuery({
    queryKey: queryKeys.catalog.deviceModels(activeOnly),
    queryFn: async () => {
      const res = await catalogAdminClient.listDeviceModels({
        query: { activeOnly: activeOnly ? 'true' : undefined },
      });
      if (res.status !== 200) throw new Error('Failed to load models');
      return res.body;
    },
  });
};

export const useDeviceModel = (id: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.catalog.deviceModel(id),
    queryFn: async () => {
      const res = await catalogAdminClient.getDeviceModel({
        params: { id: id! },
      });
      if (res.status !== 200) throw new Error('Failed to load model');
      return res.body;
    },
    enabled: !!id,
  });
};

// Device Variants hooks
export const useDeviceVariants = (
  deviceModelId?: string,
  activeOnly?: boolean
) => {
  return useQuery({
    queryKey: queryKeys.catalog.deviceVariants(deviceModelId, activeOnly),
    queryFn: async () => {
      const res = await catalogAdminClient.listDeviceVariants({
        query: { deviceModelId, activeOnly: activeOnly ? 'true' : undefined },
      });
      if (res.status !== 200) throw new Error('Failed to load variants');
      return res.body;
    },
    enabled: !!deviceModelId,
  });
};

// Accessories hooks
export const useAccessories = (activeOnly?: boolean) => {
  return useQuery({
    queryKey: queryKeys.catalog.accessories(activeOnly),
    queryFn: async () => {
      const res = await catalogAdminClient.listAccessories({
        query: { activeOnly: activeOnly ? 'true' : undefined },
      });
      if (res.status !== 200) throw new Error('Failed to load accessories');
      return res.body;
    },
  });
};

